module.exports = __webpack_public_path__ + "static/img/icon_04@2x.242e62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry-version/icon_04@2x.png
// module id = 922
// module chunks = 2